import { Button } from '@components/ui'
import { useQuery } from '@tanstack/react-query'
import { Col, Flex, Row, Spin } from 'antd'

import { useFramework } from '@suntex.fim/framework'

import { redirectToLink } from './util'

/**
 * returns JSX for recognition
 */
function Recognition() {
  const { api } = useFramework()
  const { data } = useQuery({
    queryKey: ['webflow', 'recognition'],
    queryFn: () => api.get_WebFlow_Recognition({})
  })
  if (!data) return <Spin />
  return (
    <Flex vertical>
      {/* heading */}
      <div className="main-navigation">
        <h3 className="main-navigation__heading">Recognition</h3>
        <div className="main-navigation__subheading">
          {data.infoFieldData['recognition-description'] ?? ''}
        </div>
      </div>
      {/* Game tiles */}
      <Row gutter={[24, 24]} className="resources-column-wrapper">
        {data.toolsFieldData
          .sort((a, b) => a.name?.localeCompare(b.name ?? '') ?? 0)
          .map((item) => (
            <Col xs={24} md={6} key={item.name}>
              <Flex
                vertical
                justify="space-between"
                className="card card--recognition"
                gap="10px"
              >
                <div className="card-img-top">
                  <img src={item.icon.url} alt={item.icon.alt ?? ''} />
                </div>
                <div className="card-body">
                  <div className="card-title fw-bold">{item.name ?? ''}</div>
                </div>
                <Button
                  intent="secondary"
                  onClick={() => redirectToLink(item['view-detail-link'] ?? '')}
                >
                  View Details
                </Button>
              </Flex>
            </Col>
          ))}
      </Row>
      {/* Video section */}
      <Row gutter={[16, 16]} className="resources-column-wrapper">
        <Col span={24}>
          <iframe
            width="100%"
            height="489"
            src={data.infoFieldData['youtube-video-link']}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </Col>
      </Row>
    </Flex>
  )
}

export default Recognition
